import Vue from "vue";
import Router from "vue-router";
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/

//所有权限通用路由表
//如首页和登录页和一些不用权限的公用页面
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/error/401",
    component: () => import("@/views/error/401"),
    hidden: true
  },
  {
    path: "/error/404",
    component: () => import("@/views/error/404"),
    hidden: true
  },
  {
    path: "",
    component: Layout,
    name: "Index",
    hidden: true,
    children: [
      {
        path: "/",
        name: "Dashboard",
        meta: { title: "首页", icon: "dashboard", affix: true },
        component: () => import("@/views/dashboard/index")
      }
    ]
  },
  {
    path: "",
    component: Layout,
    name: "Info",
    hidden: true,
    children: [
      {
        path: "/info",
        component: () => import("@/views/info/index")
      }
    ]
  },
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path*",
        component: () => import("@/views/redirect/index")
      }
    ]
  }
];

//实例化vue的时候只挂载constantRouter
export default new Router({
  mode: "history",
  routes: constantRouterMap
});

//异步挂载的路由
//动态需要根据权限加载的路由表
//meta无permissions字段则不做权限控制
export const asyncRouterMap = [
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "user",
    meta: { title: "用户管理", permissions: ["user","transferLog","testUserList"], icon: "users" },
    children: [
      {
        path: "/user/list",
        name: "users",
        component: () => import("@/views/user/index"),
        meta: { title: "用户列表", permissions: ["user"] }
      },
      {
        path: "/user/invite-log",
        name: "inviteLog",
        component: () => import("@/views/user/inviteLog"),
        meta: { title: "邀请记录", permissions: ["user"] }
      },
      {
        path: "/user/point",
        name: "point",
        component: () => import("@/views/user/point"),
        meta: { title: "用户积分", permissions: ["user"] }
      },
    ]
  },
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "token",
    meta: { title: "代币管理", permissions: ["token"], icon: "content" },
    children: [
      {
        path: "/token/list",
        name: "tokens",
        component: () => import("@/views/token/index"),
        meta: { title: "代币列表", permissions: ["token"] }
      },
      {
        path: "/token/trade",
        name: "trades",
        component: () => import("@/views/token/trade"),
        meta: { title: "交易记录", permissions: ["token"] }
      },
      {
        path: "/token/tag",
        name: "tags",
        component: () => import("@/views/token/tag"),
        meta: { title: "标签列表", permissions: ["token"] }
      },
      {
        path: "/token/issuer",
        name: "issuers",
        component: () => import("@/views/token/issuer"),
        meta: { title: "发行方", permissions: ["token"] }
      },
    ]
  },
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "order",
    meta: { title: "订单管理", permissions: ["order"], icon: "order" },
    children: [
      {
        path: "/order/list",
        name: "orders",
        component: () => import("@/views/order/index"),
        meta: { title: "解锁订单", permissions: ["order"] }
      },
      {
        path: "/order/wallet-hub",
        name: "videoWalletHub",
        component: () => import("@/views/order/videoWalletHub"),
        meta: { title: "视频钱包库", permissions: ["order"] }
      },
    ]
  },
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "node",
    meta: { title: "节点管理", permissions: ["nftPlan"], icon: "content" },
    children: [
      {
        path: "/node/plan",
        name: "nodePlan",
        component: () => import("@/views/node/plan"),
        meta: { title: "节点套餐", permissions: ["nftPlan"] }
      },
      {
        path: "/node/order",
        name: "nodeOrder",
        component: () => import("@/views/node/order"),
        meta: { title: "节点订单", permissions: ["nftPlan"] }
      },
      {
        path: "/node/reward",
        name: "nodeReward",
        component: () => import("@/views/node/reward"),
        meta: { title: "节点推荐奖励", permissions: ["nftPlan"] }
      }
    ]
  },
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "comment",
    meta: { title: "评论管理", permissions: ["comment"], icon: "log" },
    children: [
      {
        path: "/comment/list",
        name: "comments",
        component: () => import("@/views/comment/index"),
        meta: { title: "评论列表", permissions: ["order"] }
      },
    ]
  },
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "admin",
    meta: { title: "系统管理", permissions: ["admin"], icon: "admin" },
    children: [
      // {
      //   path: "/menu/list",
      //   name: "menus",
      //   component: () => import("@/views/menu/index"),
      //   meta: { title: "菜单列表", permissions: ["menu"] }
      // },
      // {
      //   path: "/role/list",
      //   name: "roles",
      //   component: () => import("@/views/role/index"),
      //   meta: { title: "角色列表", permissions: ["role"] }
      // },
      {
        path: "/admin/list",
        name: "admins",
        component: () => import("@/views/admin/index"),
        meta: { title: "管理员列表", permissions: ["admin"] }
      },
      {
        path: "/system/wallet",
        name: "wallet",
        component: () => import("@/views/system/wallet"),
        meta: { title: "系统钱包", permissions: ["admin"] }
      },
      {
        path: "/system/config",
        name: "Config",
        component: () => import("@/views/system/config"),
        meta: { title: "参数设置", permissions: ["admin","systemConfig"] }
      },
    ]
  },

  { path: "*", redirect: "/error/404", hidden: true }
];
